// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.multi-select-container {
    position: relative;
    width: 100%;
}

.field {
    background: #FFFFFF;
    border: 1px solid #D9D9D9 !important;
    border-radius: 10px !important;
    height: 50px !important;
}

.dropdown-trigger {
    cursor: pointer;
    transition: border-color 0.2s;
}

.dropdown-trigger:hover {
    border-color: #64748b !important;
}

.dropdown-content-panel {
    position: absolute;
    background-color: #ffffff;
    min-width: 100%;
    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
    z-index: 10;
    max-height: 300px;
    overflow-y: auto;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
}

.dropdown-content-panel ul {
    padding-inline-start: 0 !important;
    max-height: 200px;
    overflow-y: auto;
    overscroll-behavior: contain;
    margin-top: 10px;
}

.dropdown-content-panel li {
    list-style: none;
    cursor: pointer;
    padding: 10px 15px;
    font-size: 13px;
    border-radius: 4px;
    transition: background 0.2s;
}

.dropdown-content-panel li:hover {
    background-color: #f1f5f9;
}

.selected-item-highlight {
    background-color: #f1f5f9;
    color: #4f46e5;
    font-weight: 500;
}

.has-search .form-control-feedback {
    position: absolute;
    z-index: 2;
    display: block;
    width: 2.375rem;
    height: 3.5rem;
    line-height: 3.5rem;
    text-align: center;
    color: #aaa;
}

.form-control {
    padding-left: 2.375rem !important;
    height: 45px !important;
    border-radius: 8px !important;
}

.disabled {
    pointer-events: none;
    background: #f1f5f9 !important;
    opacity: 0.7;
}
`, "",{"version":3,"sources":["webpack://./src/app/shared/components/multi-select-dropdown/multi-select-dropdown.component.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,oCAAoC;IACpC,8BAA8B;IAC9B,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,6BAA6B;AACjC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;IACf,+CAA+C;IAC/C,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,+BAA+B;IAC/B,gCAAgC;AACpC;;AAEA;IACI,kCAAkC;IAClC,iBAAiB;IACjB,gBAAgB;IAChB,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,cAAc;IACd,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,iCAAiC;IACjC,uBAAuB;IACvB,6BAA6B;AACjC;;AAEA;IACI,oBAAoB;IACpB,8BAA8B;IAC9B,YAAY;AAChB","sourcesContent":[".multi-select-container {\n    position: relative;\n    width: 100%;\n}\n\n.field {\n    background: #FFFFFF;\n    border: 1px solid #D9D9D9 !important;\n    border-radius: 10px !important;\n    height: 50px !important;\n}\n\n.dropdown-trigger {\n    cursor: pointer;\n    transition: border-color 0.2s;\n}\n\n.dropdown-trigger:hover {\n    border-color: #64748b !important;\n}\n\n.dropdown-content-panel {\n    position: absolute;\n    background-color: #ffffff;\n    min-width: 100%;\n    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);\n    z-index: 10;\n    max-height: 300px;\n    overflow-y: auto;\n    border-bottom-left-radius: 10px;\n    border-bottom-right-radius: 10px;\n}\n\n.dropdown-content-panel ul {\n    padding-inline-start: 0 !important;\n    max-height: 200px;\n    overflow-y: auto;\n    overscroll-behavior: contain;\n    margin-top: 10px;\n}\n\n.dropdown-content-panel li {\n    list-style: none;\n    cursor: pointer;\n    padding: 10px 15px;\n    font-size: 13px;\n    border-radius: 4px;\n    transition: background 0.2s;\n}\n\n.dropdown-content-panel li:hover {\n    background-color: #f1f5f9;\n}\n\n.selected-item-highlight {\n    background-color: #f1f5f9;\n    color: #4f46e5;\n    font-weight: 500;\n}\n\n.has-search .form-control-feedback {\n    position: absolute;\n    z-index: 2;\n    display: block;\n    width: 2.375rem;\n    height: 3.5rem;\n    line-height: 3.5rem;\n    text-align: center;\n    color: #aaa;\n}\n\n.form-control {\n    padding-left: 2.375rem !important;\n    height: 45px !important;\n    border-radius: 8px !important;\n}\n\n.disabled {\n    pointer-events: none;\n    background: #f1f5f9 !important;\n    opacity: 0.7;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
